<script lang="ts">
  export let disabled = false;
</script>

<button class={`button-v ${$$restProps.class || ''}`} {disabled}>
  <div class="button-v-content">
    <span class="button-v-text">
      <slot />
    </span>
  </div>
</button>

<style lang="scss"></style>
